var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMypageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2136_9340)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.4 13.8C9.3 14.9 10.6 15.5 12 15.6C13.4 15.5 14.7 14.9 15.6 13.8M21 12C21 17 17 21 12 21C7 21 3 17 3 12C3 7 7 3 12 3C17 3 21 7 21 12Z",
    stroke: "#F4A460",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.29999 10.3C9.85227 10.3 10.3 9.85233 10.3 9.30005C10.3 8.74776 9.85227 8.30005 9.29999 8.30005C8.7477 8.30005 8.29999 8.74776 8.29999 9.30005C8.29999 9.85233 8.7477 10.3 9.29999 10.3Z",
    fill: "#F4A460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7 10.3C15.2523 10.3 15.7 9.85233 15.7 9.30005C15.7 8.74776 15.2523 8.30005 14.7 8.30005C14.1477 8.30005 13.7 8.74776 13.7 9.30005C13.7 9.85233 14.1477 10.3 14.7 10.3Z",
    fill: "#F4A460"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2136_9340"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMypageIcon);
export default __webpack_public_path__ + "static/media/mypage-icon.f87eb56ce35175f3a21599682ff701a2.svg";
export { ForwardRef as ReactComponent };